var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 46,
    viewBox: "0 0 47 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 47,
    height: 46,
    rx: 10,
    fill: "#6D5FF2",
    fillOpacity: 0.14
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.7251 31.4772C19.5122 31.7513 20.447 31.9317 21.5293 32.0183V34.0156H18.7251V31.4772ZM24.727 34.0156H27.5312V31.4575C26.6948 31.7333 25.7601 31.9161 24.727 32.006V34.0156ZM22.9815 11.9844C21.7128 11.9844 20.6841 13.3225 20.6841 14.973C20.6841 16.6235 21.7128 17.9616 22.9815 17.9616C24.2502 17.9616 25.2789 16.6235 25.2789 14.973C25.2789 13.3225 24.2503 11.9844 22.9815 11.9844ZM33.3259 25.4064C33.3259 21.2002 30.1341 17.6296 25.7926 16.5374C25.6581 16.9067 25.4685 17.2535 25.2302 17.5661C24.6527 18.3178 23.8331 18.7468 22.982 18.7468C22.131 18.7468 21.3094 18.3158 20.7338 17.5661C20.4973 17.2557 20.3088 16.9116 20.1744 16.5453C15.8487 17.6468 12.6741 21.2105 12.6741 25.4064H14.1992C14.1969 24.3274 14.4529 23.2635 14.946 22.3036C14.8453 22.7783 14.7945 23.2623 14.7945 23.7475C14.7945 27.9144 16.2305 31.2906 23.0008 31.2906C30.1882 31.2906 31.2071 27.9119 31.2071 23.7451C31.2071 23.2605 31.1563 22.7772 31.0555 22.3032C31.5481 23.2633 31.8037 24.3273 31.8009 25.4064H33.3259Z",
    fill: "#6D5FF2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFat);
export default __webpack_public_path__ + "static/media/Fat.9dcfd5c67cd316941ad354978431daf4.svg";
export { ForwardRef as ReactComponent };